<div class="drop-container">
  @if (!selectedOfficeIsUserOffice) {
    <i class="fas fa-exclamation-triangle" style="color: orange; margin-right: 5px;"
      ngbTooltip="No tienes seleccionada tu oficina principal, tienes restringidas tus funcionalidades"
      placement="bottom"></i>
  }
  <span class="loc" (click)="onSelectOffice($event)">{{selectedOfficeName || 'Sin oficina'}}</span>
</div>
<modal-dialog dialogId="officeSelectorDialog" #modalDialog title="Seleccione una oficina"
    [cancelText]="canCancelDialog?'Cerrar':null">
    <loading-overlay [show]="dialogLoading">
        <div class="container">
            <input type="text" class="form-control" name="office" placeholder="Introduzca un texto de búsqueda" aria-label="Oficina"
                [(ngModel)]="searchText">
        </div>
        <div class="container">
          @for (company of (companies | officeSelectorFilterCompany:searchText); track company.id) {
            <div class="card" style="width: 100%;">
                <div class="card-header">
                    <a (click)="company.isCollapsed = !company.isCollapsed"
                        style="text-align: left; font-size: 16px; font-weight: 400; color: #414648; margin: .75rem 0rem;"
                        [attr.aria-expanded]="!company.isCollapsed"
                        attr.aria-controls="#companyOfficeGroup{{company.id}}">
                        @if (!company.isCollapsed) {
                          <i class="material-icons" style="font-size: 24px; color: #414648; vertical-align: text-bottom;">keyboard_arrow_down</i>
                        }

                        @if (company.isCollapsed) {
                          <i class="material-icons" style="font-size: 24px; color: #414648; vertical-align: text-bottom;">keyboard_arrow_right</i>
                        }
                        {{company.fiscalName}}
                    </a>
                </div>
                <div id="companyOfficeGroup{{company.id}}" [ngbCollapse]="company.isCollapsed">
                    <ul class="list-group list-group-flush">
                      @for (office of (company.offices | officeSelectorFilterOffice:searchText); track office.id) {
                       <li class="list-group-item"
                            (click)="onOfficeSelected($event, office)">{{office.selectName}}</li>
                      }
                    </ul>
                </div>
            </div>
          }
        </div>
    </loading-overlay>
</modal-dialog>
